import axios from "axios";
import { getEnvironment } from "../../utility/util";

const apiLogin = axios.create({
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
});

// var envi = getEnvironment();
apiLogin.defaults.baseURL = "https://service.onehcm.id/";
// if (envi === "Dev") {
//   apiLogin.defaults.baseURL = "https://servicedev.onehcm.id/";
  // apiLogin.defaults.baseURL = "https://platocoredev.azurewebsites.net/";
// } else {
  // apiLogin.defaults.baseURL = "https://service.onehcm.id/";
  // apiLogin.defaults.baseURL = "https://platocore.azurewebsites.net/";
// }
// if (envi === "Dev") {
//   apiLogin.defaults.baseURL = "https://platocoredev.azurewebsites.net/";
// } else {
//   apiLogin.defaults.baseURL = "https://plato-coreapp.azurewebsites.net/";
// }

// apiLogin.defaults.baseURL = "http://gateway2.southeastasia.cloudapp.azure.com/";
// apiLogin.defaults.baseURL = 'https://hrmspayrollengine.azurewebsites.net/'
// apiLogin.defaults.baseURL = 'http://20.197.120.246/'
// apiLogin.defaults.timeout = 300000;
apiLogin.interceptors.request.use(
  (config) => {
    // if (token) {
    //   config.headers["Authorization"] = `Bearer ${token}`;
    //   // apiLogin.defaults.headers.common['Authorization'] = `Bearer ${token}`
    // }
    // config.headers["Authorization"] = null;
    return config;
  },
  (error) => Promise.reject(error)
);


export default apiLogin;
